import { DateFieldComponent } from '@app/forms/formly/types/date-field/date-field.component';
import { InputFieldComponent } from '@app/forms/formly/types/input-field/input-field.component';
import { RadioFieldComponent } from '@app/forms/formly/types/radio-field/radio-field.component';
import { TravelerCardsComponent } from '@app/forms/formly/types/traveler-cards/traveler-cards.component';
import {
  BackendValidatorMessage,
  EmailValidator,
  PhoneValidator,
  DateValidator,
  RequiredValidatorMessage,
} from '@app/forms/formly/validators/validators';
import { FieldWrapperComponent } from '@app/forms/formly/wrappers/field-wrapper/field-wrapper.component';
import { DropdownFieldComponent } from '@app/forms/formly/types/dropdown-field/dropdown-field.component';
import { CcNumberFieldComponent } from '@app/forms/formly/types/cc-number-field/cc-number-field.component';
import { CcExpirationFieldComponent } from '@app/forms/formly/types/cc-expiration-field/cc-expiration-field.component';
import { CcCvvFieldComponent } from '@app/forms/formly/types/cc-cvv-field/cc-cvv-field.component';
import { CurrencyFieldComponent } from '@app/forms/formly/types/currency-field/currency-field.component';
import { PhoneFieldComponent } from '@app/forms/formly/types/phone-field/phone-field.component';
import { InfoBlockFieldComponent } from '@app/forms/formly/types/info-block-field/info-block-field.component';
import { CardWrapperComponent } from '@app/forms/formly/wrappers/card-wrapper/card-wrapper.component';
import { CustomFieldComponent } from '@app/forms/formly/types/custom-field/custom-field.component';
import { CheckboxFieldComponent } from '@app/forms/formly/types/checkbox-field/checkbox-field.component';
import { PlanningTripComponent } from '@app/forms/formly/types/planning-trip/planning-trip.component';
import { InputFieldWithAutocompleteComponent } from '@app/forms/formly/types/input-field-with-autocomplete/input-field-with-autocomplete.component';
import { RangePickerDropdownComponent } from '@app/forms/formly/types/range-picker-dropdown/range-picker-dropdown.component';
import { FoldCardWrapperComponent } from '@app/forms/formly/wrappers/fold-card-wrapper/fold-card-wrapper.component';
import { ShortDateComponent } from '@app/forms/formly/types/short-date/short-date.component';
import { RepeatComponent } from '@app/forms/formly/types/repeat/repeat.component';

export const formlyConfig = {
  types: [
    { name: 'input', component: InputFieldComponent },
    {
      name: 'input-with-autocomplete',
      component: InputFieldWithAutocompleteComponent,
      wrappers: ['field-wrapper'],
    },
    {
      name: 'range-picker',
      component: RangePickerDropdownComponent,
    },
    { name: 'cc-expiration', component: CcExpirationFieldComponent },
    { name: 'cc-cvv', component: CcCvvFieldComponent },
    { name: 'cc-number', component: CcNumberFieldComponent },
    { name: 'phone', component: PhoneFieldComponent },
    { name: 'radio', component: RadioFieldComponent, wrappers: ['field-wrapper'] },
    { name: 'checkbox', component: CheckboxFieldComponent, wrappers: ['field-wrapper'] },
    { name: 'date', component: DateFieldComponent, wrappers: ['field-wrapper'] },
    { name: 'dropdown', component: DropdownFieldComponent, wrappers: ['field-wrapper'] },
    { name: 'traveler-cards', component: TravelerCardsComponent, wrappers: ['field-wrapper'] },
    { name: 'planning-trip', component: PlanningTripComponent, wrappers: ['field-wrapper'] },
    { name: 'currency', component: CurrencyFieldComponent },
    { name: 'info-block', component: InfoBlockFieldComponent },
    { name: 'custom', component: CustomFieldComponent },
    { name: 'short-date', component: ShortDateComponent, wrappers: ['field-wrapper'] },
    { name: 'repeat', component: RepeatComponent },
  ],
  wrappers: [
    { name: 'field-wrapper', component: FieldWrapperComponent },
    { name: 'card-wrapper', component: CardWrapperComponent },
    { name: 'fold-card-wrapper', component: FoldCardWrapperComponent },
  ],
  validators: [
    { name: 'email', validation: EmailValidator },
    { name: 'phone', validation: PhoneValidator },
    { name: 'date', validation: DateValidator },
  ],
  validationMessages: [
    { name: 'required', message: RequiredValidatorMessage },
    { name: 'backend', message: BackendValidatorMessage },
    { name: 'max', message: 'Incorrect amount' },
    { name: 'invalid', message: 'Invalid value' },
    { name: 'cc-number-invalid', message: 'Please enter a valid card number' },
    { name: 'email', message: 'Invalid email address' },
    { name: 'phone', message: 'Invalid phone' },
    { name: 'date', message: 'Invalid date' },
  ],
};
